<template>
  <div class="icon-menu">
    <v-menu bottom left offset-y :nudge-left="offsetLeft" :nudge-top="offsetTop" :nudge-right="offsetRight" :nudge-bottom="offsetBottom">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <slot name="icon"><apio-icon name="ui-more-B"></apio-icon></slot>
        </div>
      </template>

      <v-list class="icon-menu__list">
        <slot name="icon-menu-list" />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    offsetLeft: {
      default: 12,
    },
    offsetTop: {
      default: 0,
    },
    offsetRight: {
      default: 12,
    },
    offsetBottom: {
      default: 0,
    }
  }
};
</script>

<style lang="scss">
.icon-menu {
  display: flex;
  align-items: center;
  &__list {
    border-radius: 4px;
    min-width: 175px;
    height: fit-content;
    width: fit-content;
    padding: 6px 0 2px 0 !important;

    box-shadow: none !important;

    &__dark {
      background: var(--apio-shade-2) !important;
      border: 1px solid #fff !important;
      color: white;
    }
  }
  &__item-icon {
    height: 48px;
  }

  &__item {
    width: 175px;
    height: 26px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    line-height: 26px;
    font-size: 14px;
    font-weight: normal;
    padding: 0 4px 0 8px;
    cursor: pointer;

    &:hover {
      text-decoration: none !important;
      color: var(--apio-blue-black) !important;
      background: var(--apio-shade-5) !important;
    }

    &__dark {
      border: 1px solid #fff !important;
      background: #1e1e1e;
    }
  }
}
</style>